import apiClient from "./client";

export async function fetchLoanApplicationsDashboard() {
  const { data } = await apiClient.get("/loans/applications/dashboard");
  return data;
}
